import React, { createContext, useState, useMemo, useEffect } from "react";

export const PatientContext = createContext();

export default function PatientContextProvider({ children }) {
   const [patient, setPatient] = useState(() => {
      const saved = localStorage.getItem("patient");
      return saved ? JSON.parse(saved) : {};
   });

   const [loading, setLoading] = useState(false);

   useEffect(() => {
      localStorage.setItem("patient", JSON.stringify(patient));
   }, [patient]);

   const contextValue = useMemo(
      () => ({ patient, setPatient, loading, setLoading }),
      [patient, loading]
   );

   return (
      <PatientContext.Provider value={contextValue}>
         {children}
      </PatientContext.Provider>
   );
}
